"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var CartContainer_1 = require("../components/Cart/CartContainer");
var targetNode = document.querySelector('.slide-cart-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(CartContainer_1.default, null), targetNode);
}
